import { useCallback, useMemo } from 'react'

import { selectIsIntegrationUploading } from './integrationBarSelectors'
import {
  integrationUploadFinished,
  integrationUploadStarted,
} from './integrationBarSlice'
import type { IntegrationImport } from './integrationBarSlice'
import { useAppDispatch, useAppSelector } from '../../store'

export const useIsIntegrationUploading = (): {
  isIntegrationUploading: boolean
  onUploadStarted: (activeImport?: IntegrationImport) => void
  onUploadFinished: () => void
} => {
  const dispatch = useAppDispatch()
  const isIntegrationUploading = useAppSelector(selectIsIntegrationUploading)

  const onUploadStarted = useCallback(
    (activeImport?: IntegrationImport) => {
      dispatch(integrationUploadStarted(activeImport))
    },
    [dispatch],
  )

  const onUploadFinished = useCallback(() => {
    dispatch(integrationUploadFinished())
  }, [dispatch])

  return useMemo(() => {
    return {
      isIntegrationUploading,
      onUploadStarted,
      onUploadFinished,
    }
  }, [isIntegrationUploading, onUploadStarted, onUploadFinished])
}
